import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingHexColorPickerFromImageConfig } from '@/data/landingConfig/landingHexColorPickerFromImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_HexColorPickerFromImage } from './schemaObject';

interface Props {}
const HexColorPickerFromImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_HexColorPickerFromImage} />
			<LandingTemplate
				data={landingHexColorPickerFromImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelColorPicker()}
			/>
		</>
	);
};

export default HexColorPickerFromImage;
